var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectedIcon = function SvgSelectedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.796 7.455c.439.439.439 1.151 0 1.59l-7.5 7.5c-.44.44-1.152.44-1.591 0l-4.5-4.5a1.125 1.125 0 0 1 1.59-1.59l3.705 3.704 6.704-6.704c.44-.44 1.152-.44 1.592 0",
    clipRule: "evenodd"
  })));
};
export default SvgSelectedIcon;